export enum DialogType {
  TopLevelTrip,
  RequestTrip,
}
